import {isOwner} from './enum/e-role'

export const OWNER_REPORT_SECTIONS = Object.freeze([
  {id: 'overview', label: 'Dashboard'},
  {id: 'income-expenses', label: 'Laba Rugi'},
  {id: 'balance', label: 'Neraca'},
  {id: 'cash-flow', label: 'Arus Kas'},
])

export function ownerSection(value) {
  return OWNER_REPORT_SECTIONS.some(section => section.id === value) ? value : 'overview'
}

export function ownerRouteRedirect(user, path) {
  if (isOwner(user) && !['/owner-reports', '/login'].includes(path)) return '/owner-reports'
  if (path === '/owner-reports' && !isOwner(user)) return user ? '/dashboard-utama' : '/login'
  return null
}

export function ownerReportRequest(companyId, period, divisionIds, companies) {
  const company = companies.find(item => item.id === Number(companyId))
  if (!company) throw new Error('Pilih Corp yang terdaftar.')
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(period) || period.startsWith('0000')) throw new Error('Pilih periode bulan yang valid.')
  const selected = [...new Set((divisionIds || []).map(Number))]
  if (!company.divisions.length) throw new Error('Perusahaan belum mempunyai divisi untuk laporan.')
  if (selected.some(id => id <= 0 || !company.divisions.some(division => division.id === id))) throw new Error('Divisi berada di luar Corp yang dipilih.')
  return {companyId: company.id, period, divisionIds: selected}
}

export function validateOwnerReport(report, section, request, companies) {
  const company = companies.find(item => item.id === request.companyId)
  const expectedIds = (request.divisionIds.length ? request.divisionIds : company.divisions.map(item => item.id)).slice().sort((a, b) => a - b)
  const actualIds = Array.isArray(report?.divisionIds) ? report.divisionIds.slice().sort((a, b) => a - b) : []
  if (!report || report.type !== section || report.companyId !== request.companyId || report.period !== request.period ||
      JSON.stringify(actualIds) !== JSON.stringify(expectedIds)) throw new Error('Cakupan laporan tidak sesuai permintaan. Muat ulang laporan.')
  const decimal = value => typeof value === 'string' && /^-?\d+(\.\d+)?$/.test(value)
  if (!Array.isArray(report.summary) || !Array.isArray(report.rows) ||
      report.summary.some(item => !item.label || (item.value !== null && !decimal(item.value))) ||
      report.rows.some(item => !item.label || !decimal(item.value) ||
        (section === 'cash-flow' && (!decimal(item.cashIn) || !decimal(item.cashOut))))) {
    throw new Error('Data laporan tidak valid. Muat ulang laporan.')
  }
  return report
}

export function ownerNumber(value) {
  if (typeof value !== 'string' || !/^-?\d+(\.\d+)?$/.test(value)) return '—'
  const negative = value.startsWith('-') && /[1-9]/.test(value)
  const [integer, fraction = ''] = value.replace(/^-/, '').split('.')
  const decimals = fraction.replace(/0+$/, '')
  return `${negative ? '-' : ''}${integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${decimals ? ',' + decimals : ''}`
}

export function ownerMetric(metric) {
  if (metric.value === null) return '—'
  const value = ownerNumber(metric.value)
  if (value === '—') return value
  if (metric.format === 'percent') return `${Number(metric.value).toLocaleString('id-ID', {maximumFractionDigits: 2})}%`
  return `Rp ${value}`
}

export function ownerReportFooter(report) {
  const labels = {'income-expenses': 'Laba Bersih', balance: 'Selisih', 'cash-flow': 'Arus Kas Neto'}
  return report?.summary.find(item => item.label === labels[report.type]) || null
}
